import React, { Component } from "react";
import PropTypes from "prop-types";

import SweetAlert from "sweetalert-react";
import i18n from "i18n-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Redirect } from "react-router-dom";
import { renderToStaticMarkup } from "react-dom/server";

import InputField from "components/LoginForm/Input";
import { LanguageSelect, SellingPoints, StorageHandler } from "C4";
import { companyWebsite, name, storageKeys } from "settings";

// import logo from 'assets/images/logo/logo.png';

const NoAgentScreen = ({ logo }) => (
  <div className="noAgent__container">
    <img src={logo} alt={`${name} logo`} />
    <h5>{i18n.translate("loginScreen.noAgent.title")}</h5>
    <p>{i18n.translate("loginScreen.noAgent.messageWeb")}</p>
    <p>
      <a href={companyWebsite}>{companyWebsite}</a>
    </p>
    <a href={companyWebsite}>
      <button>{i18n.translate("loginScreen.noAgent.visitWebsite")}</button>
    </a>
  </div>
);

export default class Email extends Component {
  constructor(props) {
    super(props);

    this.state = {
      noAgent: false,
      redirect: "",
      logo: null,
      appName: null,
    };
  }

  componentDidMount() {
    this.getAppInfo();
  }

  async getAppInfo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logo,
        appName: appInfo.appName,
      });
    }
  }

  render() {
    const { noAgent, redirect, logo, appName } = this.state;
    const {
      defaultVal,
      change,
      submit,
      loadingAnim,
      signUpRoute,
      forgotPasswordRoute,
    } = this.props;

    const close = () => {
      this.setState({
        noAgent: false,
      });
    };

    return (
      <div className="Email">
        <SweetAlert
          title=""
          show={noAgent}
          html
          text={renderToStaticMarkup(
            <NoAgentScreen logo={logo} close={close} />
          )}
          customClass="noAgent"
          showConfirmButton={false}
          cancelButtonText={i18n.translate("general.close")}
          showCancelButton
          onConfirm={close}
          onCancel={close}
          onEscapeKey={close}
          onOutsideClick={close}
        />
        <h3>{i18n.translate("loginScreen.welcome.headerTop")}</h3>
        <h3>Mike Molino RV Learning Center</h3>
        {/* <SellingPoints /> */}
        <h4>{i18n.translate("loginScreen.head")}</h4>
        {/* <hr /> */}
        <div className="Email__input">
          <LanguageSelect />
          <div className="inputFields">
            <legend>
              {i18n.translate("loginScreen.emailPrompt")}
              <br />
            </legend>
            <InputField
              defaultVal={defaultVal}
              change={change}
              fieldType="email"
              fieldName="email"
              fieldPlaceholder={i18n.translate("loginScreen.fields.email")}
              icon="at"
            />
            <InputField
              change={change}
              fieldType="password"
              fieldName="password"
              fieldPlaceholder={i18n.translate("loginScreen.fields.password")}
              icon="key"
              autocomplete="password"
              line
            />
          </div>
          <div className="login__form--buttons">
            <div className="Email__input--holder">
              <button
                type="button"
                className="loginView__content--request"
                onClick={() => this.setState({ noAgent: true })}
              >
                {i18n.translate("loginScreen.noAgent.noAgentButton")}
              </button>
              <button
                type="button"
                className="Email__input--button btnInverse"
                onClick={signUpRoute}
              >
                {i18n.translate("loginScreen.register")}
              </button>
              <button
                type="submit"
                onClick={submit}
                className="Email__input--button"
              >
                {loadingAnim ? (
                  <span>
                    <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                  </span>
                ) : (
                  i18n.translate("general.logIn")
                )}

                {redirect.length > 0 && <Redirect to={redirect} />}
              </button>
            </div>
            {forgotPasswordRoute}
            <button
              onClick={forgotPasswordRoute}
              className="Email__input--forgotPassword-btn"
            >
              <span className="Email__input--forgotPassword">
                {i18n.translate("loginScreen.forgot")}
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Email.propTypes = {
  defaultVal: PropTypes.string.isRequired,
  change: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  loadingAnim: PropTypes.bool.isRequired,
  signUpRoute: PropTypes.func.isRequired,
  forgotPasswordRoute: PropTypes.func.isRequired,
};

NoAgentScreen.propTypes = {
  logo: PropTypes.string,
};

NoAgentScreen.defaultProps = {
  logo: "",
};
